import {
    Component
} from "../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./offer-pricing.scss";
import {IOfferDetailsModel} from "../../../../../../models/offer/IOfferDetailsModel";
import {ICommunityModel} from "../../../../../../models/community/ICommunityModel";
import {OfferService} from "../../../../../../services/offer/OfferService";
import {OfferState} from "../../../../../../models/offer/OfferState";
import {OfferQuoteComponent} from "../quote/OfferQuoteComponent";
import {OfferQuoteConfirmedComponent} from "../quote/OfferQuoteConfirmedComponent";
import {OfferQuoteScheduledComponent} from "../quote/OfferQuoteScheduledComponent";
import {Network} from "../../../../../../network/Network";
import {Resources} from "../../../../../../resources/Resources";
import type {
    Website2PricingComponent
} from "../../../../../website2/components/pricing/Website2PricingComponent";

export class OfferPricingComponent extends Component {

    public details?: IOfferDetailsModel;
    public community?: ICommunityModel;
    public website?: boolean;

    public globalContainer: Component;
    public pricingComponent: Website2PricingComponent;

    constructor(details?: IOfferDetailsModel, community?: ICommunityModel, website?: boolean) {
        super();
        this.details = details;
        this.community = community;
        this.website = website;

        //language=HTML
        this.template = `
            <div class="${s.componentOfferPricing}">
                <div class="${s.scroll}">
                    <div class="${s.closeWrap}">
                        <div class="${s.close}">
                            <div class="${s.closeIcon}"></div>
                        </div>
                    </div>
                    <div class="${s.global}"></div>
                </div>
            </div>`;
    }

    commit() {
        super.commit();

        this.globalContainer = this.el(s.global);
        this.el(s.close).onClick(() => this.onCloseModal());
        this.renderAll(this.details);
    }

    async renderAll(details?: IOfferDetailsModel) {
        if (this.website) {
            await this.renderPricing();
            return;
        }

        if (details) {
            await this.renderQuote(details);
            return;
        }

        let quote = await OfferService.quote(this);
        if (quote) {
            await this.renderQuote(quote);
            return;
        }

        await this.renderPricing(await OfferService.active(false, this));
    }

    async renderPricing(activeOffer?: IOfferDetailsModel) {
        let {Website2PricingComponent} = await import("../../../../../website2/components/pricing/Website2PricingComponent");

        this.globalContainer.clearAll();

        this.pricingComponent = new Website2PricingComponent(true);
        this.pricingComponent.activeOffer = activeOffer;
        this.pricingComponent.onRendered = () => this.onRendered();
        this.pricingComponent.onSubscribe = async (subscription) => {
            if (this.website) {
                this.onSignup();
                return;
            }

            let quote = await OfferService.quoteSubscription(subscription, this.pricingComponent);
            if (quote) {
                await this.renderQuote(quote);
            }
        };

        this.globalContainer.render(this.pricingComponent);
        this.onRendered();
    }

    async renderQuote(quote: IOfferDetailsModel) {
        if (quote.offer.state == OfferState.PAYMENT && quote.url) {
            location.href = quote.url;
            return;
        }

        if (quote.error) {
            Network.router.static.components.notifications.notify(Resources.t("words.errorMessage"), undefined, 3000, "error");
        }

        this.globalContainer.clearAll();

        let quoteComponent: OfferQuoteComponent;
        switch (quote.offer.state) {
            case OfferState.CONFIRMED:
                quoteComponent = new OfferQuoteComponent(quote);
                break;
            case OfferState.PAYMENT:
            case OfferState.FAILURE_TO_PAY_AND_LOCK:
            case OfferState.SUSPENDED_AND_LOCK:
            case OfferState.FAILURE_TO_PAY:
                quoteComponent = new OfferQuoteConfirmedComponent(quote);
                break;
            case OfferState.SCHEDULED:
                quoteComponent = new OfferQuoteScheduledComponent(quote);
                break;
        }

        quoteComponent.onStep = (details) => this.renderAll(details);
        quoteComponent.onCloseModal = () => this.onCloseModal();

        this.globalContainer.render(quoteComponent);
        this.onRendered();
    }

    onCloseModal() {

    }

    onRendered() {

    }

    onSignup() {

    }
}
